// extracted by mini-css-extract-plugin
export default {"tabs":"aC1wJ4"};